export class Estatement {
    public id: string;
    public practiceId: string;
    public practiceName: string;
    public invoice: Invoice;
    public denyCodes: DenyCode[];
    public status: number;
}

export class DenyCode {
    public code: string;
    public description: string;
    public hovered: boolean = false;
}


export class Invoice {
    public aging180: string;
    public aging150: string;
    public aging120: string;
    public aging90: string;
    public aging60: string;
    public aging30: string;
    public agingCurrent: string;
    public totalDuePat: string;
    public totalDueIns: string;
    public totalPatPmt: string;
    public totalInsPmt: string;
    public totalChgPendIns: string;
    public totalBalance: string;
    public serviceLines: ServiceLineSt[];
    public garantor: PatientSt;
    public patient: PatientSt;
    public pType: string;
    public amountDue: string;
    public dateDue: Date;
    public invoiceDate: Date;
    public invoiceNo: string;
    public company: string;
    public notes: string;
}
export class ServiceLineSt {
    public serviceDateFrom: Date;
    public doctor: string;
    public cptCode: string;
    public cptDescription: string;
    public payDescription: string;
    public charge: string;
    public insPmt: string;
    public ptPmt: string;
    public adjust: string;
    public balance: string;
}
export class PatientSt {
    public account: string;
    public name: PersonName;
    public address: Address;
    public birthDate: Date;
    public gender: string;
    public homePhone: string;
    public workPhone: string;
    public mobilePhone: string;
    public email: string;
}
export class Address {
    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public zip: string;
}
export class PersonName {
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public salutation: string;
    public suffix: string;
    public nickname: string;
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/models/invoice.model.ts